export default "__VITE_ASSET__Cdp6q8Sz__"